import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useAssessmentInvitesList(
  businessId: string | undefined,
  limit?: number,
  options: {
    /** Poll while invitations are in flight (the onboarding done screen). */
    refetchInterval?: number | false;
    enabled?: boolean;
  } = {},
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.assessmentTests.listAssessmentInvites.queryOptions(
      { businessId: businessId ?? "", limit: limit ?? 80 },
      {
        enabled: Boolean(businessId) && (options.enabled ?? true),
        refetchInterval: options.refetchInterval ?? false,
        refetchIntervalInBackground: false,
      },
    ),
  );
}

/** Readiness per team (3 done and 70 %) from the roster and the invitations (GRA-173). */
export function useTeamReadiness(businessId: string | undefined, options: { enabled?: boolean } = {}) {
  const trpc = useTRPC();
  return useQuery(
    trpc.intelligence.assessmentTests.teamReadiness.queryOptions(
      { businessId: businessId ?? "" },
      { enabled: Boolean(businessId) && (options.enabled ?? true), staleTime: 15_000 },
    ),
  );
}
